import { useI18n } from "../../i18n/I18nProvider.js";

/** React admin interface copy only. Canonical lesson and article content is never translated here. */
const persian: Record<string, string> = {
    "Administration": "مدیریت",
    "Backend requis": "اتصال به سرور لازم است",
    "Le panel éditorial fonctionne uniquement avec Supabase configuré.": "کارگاه ویرایش تنها با تنظیم Supabase کار می‌کند.",
    "Vérification de la session…": "در حال بررسی نشست…",
    "Connexion requise": "ورود لازم است",
    "Connectez-vous avec votre compte administrateur avant d’ouvrir l’atelier éditorial.": "برای باز کردن کارگاه محتوا با حساب مدیر وارد شوید.",
    "Se connecter": "ورود",
    "Vérification des droits éditoriaux…": "در حال بررسی دسترسی ویرایش…",
    "Accès administrateur requis": "دسترسی مدیر لازم است",
    "Ce compte n’est pas dans l’allowlist éditoriale.": "این حساب مجوز ویرایش ندارد.",
    "Vérification impossible": "بررسی ممکن نیست",
    "Le serveur n’a pas pu confirmer les droits administrateur.": "سرور نتوانست دسترسی مدیر را تأیید کند.",
    "Créer, réviser et publier le corpus canonique.": "محتوای اصلی را ایجاد، بازبینی و منتشر کنید.",
    "Préparer, relire et publier le corpus canonique sans exposer de clé serveur.": "محتوای اصلی را بدون افشای کلید سرور آماده، بازبینی و منتشر کنید.",
    "Atelier des contenus": "کارگاه محتوا",
    "Nouveau contenu": "محتوای جدید",
    "Sections de l’atelier": "بخش‌های کارگاه",
    "Contenus": "محتواها",
    "Imports": "وارد کردن‌ها",
    "Vue d’ensemble": "نمای کلی",
    "Modifier": "ویرایش",
    "Chaque sauvegarde produit une révision immuable.": "هر بار ذخیره، نسخه‌ای تغییرناپذیر ایجاد می‌کند.",
    "Enregistrez vos modifications en brouillon avant de publier.": "پیش از انتشار، تغییرات را به‌صورت پیش‌نویس ذخیره کنید.",
    "erreur(s) éditoriale(s) bloquent la publication.": "خطای ویرایشی مانع انتشار است.",
    "Révision": "نسخه",
    "enregistrée en brouillon.": "به‌صورت پیش‌نویس ذخیره شد.",
    "publiée.": "منتشر شد.",
    "Contenus suivis": "محتواهای ثبت‌شده",
    "Publiés": "منتشرشده",
    "Brouillons en attente": "پیش‌نویس‌های در انتظار",
    "Couverture publiée": "پوشش انتشار",
    "Inventaire serveur": "فهرست محتوای سرور",
    "résultat(s)": "نتیجه",
    "leçon": "درس",
    "pack": "بسته",
    "Action interrompue": "عملیات متوقف شد",
    "Édition interrompue": "ویرایش متوقف شد",
    "Terminé": "انجام شد",
    "Qualité": "کیفیت",
    "Qualité avant publication": "کیفیت پیش از انتشار",
    "Complétion éditoriale": "تکمیل ویرایشی",
    "erreur(s)": "خطا",
    "conseil(s)": "پیشنهاد",
    "Type": "نوع",
    "Type de contenu": "نوع محتوا",
    "Identifiant stable": "شناسهٔ ثابت",
    "Identifiant": "شناسه",
    "Version du schéma": "نسخهٔ ساختار",
    "Provenance": "منبع",
    "Titre français": "عنوان فرانسوی",
    "Présentation": "معرفی",
    "Publication": "انتشار",
    "Illustration": "تصویر",
    "Article": "مقاله",
    "caractères": "نویسه",
    "Sources vérifiables": "منابع قابل‌بررسی",
    "Vocabulaire clé": "واژگان کلیدی",
    "Supprimer ce mot": "حذف این واژه",
    "Connexions Grammaire": "پیوندهای دستور زبان",
    "Point de grammaire": "نکتهٔ دستوری",
    "Supprimer ce point": "حذف این نکته",
    "Ajouter un point de grammaire": "افزودن نکتهٔ دستوری",
    "Non précisé": "مشخص نشده",
    "Source": "منبع",
    "Titre de la source": "عنوان منبع",
    "URL de la source": "نشانی منبع",
    "Supprimer la source": "حذف منبع",
    "Ajouter une source": "افزودن منبع",
    "Réservé aux corrections exceptionnelles. Toute modification structurée régénère ce JSON.": "فقط برای اصلاحات استثنایی. هر ویرایش ساختاری این JSON را دوباره می‌سازد.",
    "Payload JSON avancé": "محتوای JSON پیشرفته",
    "Titre persan": "عنوان فارسی",
    "Niveau": "سطح",
    "Module": "ماژول",
    "Catégorie": "دسته‌بندی",
    "Icône": "نماد",
    "Ordre": "ترتیب",
    "Durée estimée (minutes)": "زمان تقریبی (دقیقه)",
    "Importance": "اهمیت",
    "Parties annoncées": "بخش‌های اعلام‌شده",
    "Exercices annoncés": "تمرین‌های اعلام‌شده",
    "Titre du catalogue": "عنوان فهرست",
    "Titre catalogue": "عنوان فهرست",
    "Titre catalogue persan": "عنوان فارسی فهرست",
    "Titre persan du catalogue": "عنوان فارسی فهرست",
    "Icône du catalogue": "نماد فهرست",
    "Icône catalogue": "نماد فهرست",
    "Titre de la leçon": "عنوان درس",
    "Titre persan de la leçon": "عنوان فارسی درس",
    "Icône de la leçon": "نماد درس",
    "Durée de la leçon (minutes)": "مدت درس (دقیقه)",
    "Leçon prérequise à ajouter": "درس پیش‌نیاز برای افزودن",
    "Titre dans le pack": "عنوان در بسته",
    "Titre du pack en persan": "عنوان فارسی بسته",
    "Icône dans le pack": "نماد در بسته",
    "Inspiration": "الهام‌بخش",
    "Questions affichées": "پرسش‌های نمایش‌داده‌شده",
    "Question": "پرسش",
    "Questions": "پرسش‌ها",
    "Format": "قالب",
    "Énoncé": "صورت سؤال",
    "Explication française": "توضیح فرانسوی",
    "Explication persane": "توضیح فارسی",
    "Réponse attendue": "پاسخ مورد انتظار",
    "Bonne réponse": "پاسخ درست",
    "Mots proposés": "واژه‌های پیشنهادی",
    "Ordre correct": "ترتیب درست",
    "Identifiant de section": "شناسهٔ بخش",
    "Cours en mini-Markdown": "متن درس با Markdown",
    "Tableau principal": "جدول اصلی",
    "Second tableau": "جدول دوم",
    "Note": "یادداشت",
    "Note française": "یادداشت فرانسوی",
    "Note persane": "یادداشت فارسی",
    "Contenu": "محتوا",
    "Exemples": "نمونه‌ها",
    "Mots": "واژه‌ها",
    "Présentation du pack": "معرفی بسته",
    "Aperçu réel de l’article": "پیش‌نمایش مقاله",
    "Aperçu de la leçon": "پیش‌نمایش درس",
    "Langue de l’aperçu": "زبان پیش‌نمایش",
    "Aperçu sans effet de bord": "پیش‌نمایش بدون تغییر داده",
    "Nouveau pack": "بستهٔ جدید",
    "mot(s)": "واژه",
    "question(s)": "پرسش",
    "Inspiré par": "با الهام از",
    "autre(s) mot(s)": "واژهٔ دیگر",
    "Le catalogue et le détail sont volontairement éditables séparément : les différences existantes sont conservées.": "فهرست و جزئیات جداگانه قابل‌ویرایش‌اند و تفاوت‌های موجود حفظ می‌شوند.",
    "Le français d’un mot déjà publié reste stable afin de préserver la progression des apprenants.": "واژهٔ فرانسویِ منتشرشده ثابت می‌ماند تا پیشرفت زبان‌آموزان حفظ شود.",
    "Nouveau mot": "واژهٔ جدید",
    "Dupliquer": "تکثیر",
    "Mot publié protégé": "واژهٔ منتشرشده محافظت می‌شود",
    "Supprimer": "حذف",
    "Ajouter un mot": "افزودن واژه",
    "Les extensions inconnues sont conservées lors des éditions structurées.": "افزونه‌های ناشناخته هنگام ویرایش ساختاری حفظ می‌شوند.",
    "Payload JSON avancé Vocabulaire": "محتوای JSON پیشرفتهٔ واژگان",
    "Conseils": "نکته‌ها",
    "Mot français": "واژهٔ فرانسوی",
    "Traduction persane": "ترجمهٔ فارسی",
    "Pack lié": "بستهٔ مرتبط",
    "Leçon liée": "درس مرتبط",
    "Exemple": "نمونه",
    "Chapô français": "خلاصهٔ فرانسوی",
    "Chapô persan": "خلاصهٔ فارسی",
    "Niveau ou plage CECRL": "سطح یا بازهٔ CEFR",
    "Date de publication": "تاریخ انتشار",
    "URL de l’image": "نشانی تصویر",
    "Texte alternatif": "متن جایگزین تصویر",
    "Texte complet": "متن کامل",
    "Version simplifiée": "نسخهٔ ساده‌شده",
    "URL HTTPS": "نشانی HTTPS",
    "Histoire simple": "داستان ساده",
    "Histoires": "داستان‌ها",
    "Activer": "فعال‌سازی",
    "blanc(s)": "جای‌خالی",
    "Marqueurs historiques détectés : ils restent intacts. Les nouveaux blancs utilisent": "نشانگرهای قدیمی شناسایی شدند و دست‌نخورده می‌مانند. جای‌خالی‌های جدید از",
    "Blancs": "جای‌خالی‌ها",
    "Ajouter un blanc": "افزودن جای‌خالی",
    "Désactiver cette histoire": "غیرفعال‌سازی این داستان",
    "Histoire littéraire": "داستان ادبی",
    "Texte français": "متن فرانسوی",
    "Texte persan": "متن فارسی",
    "Marqueur": "نشانگر",
    "Français": "فرانسوی",
    "Persan": "فارسی",
    "Difficulté": "درجهٔ سختی",
    "Image facultative": "تصویر اختیاری",
    "Exemple français": "نمونهٔ فرانسوی",
    "Exemple persan": "نمونهٔ فارسی",
    "Grammaire": "دستور زبان",
    "Actualité": "خبر",
    "Voyage": "سفر",
    "Vocabulaire": "واژگان",
    "Leçon": "درس",
    "Exercice": "تمرین",
    "Publié": "منتشرشده",
    "Publiée": "منتشرشده",
    "Brouillon": "پیش‌نویس",
    "Archivé": "بایگانی‌شده",
    "Statut": "وضعیت",
    "Révisions": "بازبینی‌ها",
    "Historique": "تاریخچه",
    "Chargement des révisions…": "در حال بارگذاری نسخه‌ها…",
    "Publier la révision": "انتشار نسخهٔ",
    "Import initial": "وارد کردن اولیه",
    "L’analyse lit l’export historique sans le modifier. L’import crée uniquement des révisions brouillon ; la publication reste séparée.": "بررسی، خروجی قدیمی را بدون تغییر می‌خواند. وارد کردن فقط نسخه‌های پیش‌نویس می‌سازد و انتشار جداگانه است.",
    "Analyse…": "در حال بررسی…",
    "Analyser l’export": "بررسی خروجی",
    "Importer en brouillons": "وارد کردن به پیش‌نویس",
    "valides prêt(es) à être importé(es).": "مورد معتبر آمادهٔ وارد کردن است.",
    "Import": "وارد کردن",
    "J’ai vérifié les brouillons et je souhaite publier les dernières révisions": "پیش‌نویس‌ها را بررسی کرده‌ام و می‌خواهم آخرین نسخه‌های",
    "Publier": "انتشار",
    "brouillon(s)": "پیش‌نویس",
    "JSON avancé": "JSON پیشرفته",
    "Paramètres techniques": "تنظیمات فنی",
    "Enregistrer en brouillon": "ذخیره به‌عنوان پیش‌نویس",
    "Enregistrement…": "در حال ذخیره…",
    "Publication…": "در حال انتشار…",
    "Retirer": "حذف",
    "Ajouter": "افزودن",
    "Tous les types": "همهٔ نوع‌ها",
    "Rechercher un contenu": "جستجوی محتوا",
    "Titre ou identifiant…": "عنوان یا شناسه…",
    "Filtrer par type": "فیلتر بر اساس نوع",
    "Filtrer la grammaire par niveau": "فیلتر دستور زبان بر اساس سطح",
    "Tous les niveaux": "همهٔ سطح‌ها",
    "Chargement de l’inventaire…": "در حال بارگذاری فهرست…",
    "La liste privée des contenus n’a pas pu être chargée.": "فهرست خصوصی محتوا بارگذاری نشد.",
    "Importez l’export Grammaire ou créez un premier brouillon.": "دستور زبان را وارد کنید یا اولین پیش‌نویس را بسازید.",
    "Recommencer": "دوباره تلاش کنید",
    "Inventaire indisponible": "فهرست در دسترس نیست",
    "Aucun contenu": "محتوایی وجود ندارد",
    "Carte du catalogue": "کارت فهرست",
    "Recommander cette leçon dans son niveau": "پیشنهاد این درس در سطح مربوطه",
    "Prérequis": "پیش‌نیازها",
    "Retirer le prérequis": "حذف پیش‌نیاز",
    "Aucun prérequis.": "پیش‌نیازی وجود ندارد.",
    "Choisir une leçon…": "انتخاب درس…",
    "En-tête de la leçon": "سرصفحهٔ درس",
    "Le titre et l’icône peuvent volontairement différer de la carte du catalogue.": "عنوان و نماد درس می‌توانند با کارت فهرست متفاوت باشند.",
    "Les prérequis ne sont pas la liste complète des leçons : utilisez l’inventaire serveur pour modifier toute la grammaire.": "پیش‌نیازها فهرست کامل درس‌ها نیستند؛ برای ویرایش همهٔ درس‌های دستور زبان از فهرست محتوای سرور استفاده کنید.",
    "Réservé aux extensions exceptionnelles. Les champs inconnus sont conservés lors des éditions structurées.": "فقط برای افزونه‌های استثنایی. فیلدهای ناشناخته هنگام ویرایش ساختاری حفظ می‌شوند.",
    "Sections": "بخش‌ها",
    "Sections pédagogiques": "بخش‌های آموزشی",
    "Ajouter une section de cours": "افزودن بخش درس",
    "Ajouter une section et son exercice": "افزودن بخش و تمرین آن",
    "Cliquer pour modifier la section": "برای ویرایش بخش کلیک کنید",
    "Cours en français (mini-Markdown)": "متن درس به فرانسوی (Markdown ساده)",
    "Cours en persan (mini-Markdown)": "متن درس به فارسی (Markdown ساده)",
    "Cours français de la section": "متن فرانسوی بخش",
    "Cours persan de la section": "متن فارسی بخش",
    "Explication complète affichée quand le site est en persan.": "توضیح کامل هنگام انتخاب زبان فارسی نمایش داده می‌شود.",
    "Nouvelle section": "بخش جدید",
    "Monter": "بالا بردن",
    "Descendre": "پایین بردن",
    "Supprimer cette section": "حذف این بخش",
    "Section publiée protégée": "بخش منتشرشده محافظت می‌شود",
    "Ajouter un exemple": "افزودن نمونه",
    "Supprimer le tableau": "حذف جدول",
    "Exercices jouables": "تمرین‌های قابل‌اجرا",
    "Chaque section de cours peut avoir son exercice. Le quiz final porte sur toute la leçon.": "هر بخش درس می‌تواند تمرین خود را داشته باشد. آزمون پایانی کل درس را پوشش می‌دهد.",
    "Ajouter un exercice à cette section": "افزودن تمرین به این بخش",
    "Évaluation finale et exercices historiques": "ارزیابی پایانی و تمرین‌های قدیمی",
    "Les anciens exercices sans section associée restent ici et ne sont pas déplacés automatiquement.": "تمرین‌های قدیمیِ بدون بخش وابسته اینجا می‌مانند و خودکار جابه‌جا نمی‌شوند.",
    "Ajouter un quiz final": "افزودن آزمون پایانی",
    "Rattaché à la section": "وابسته به بخش",
    "Section liée au bloc": "بخش وابسته به تمرین",
    "Leçon entière / exercice historique": "کل درس / تمرین قدیمی",
    "Ces blocs sont réellement jouables. Le nombre annoncé dans le catalogue reste un objectif éditorial distinct.": "این بخش‌ها واقعاً قابل‌اجرا هستند. شمار اعلام‌شده در فهرست، هدف ویرایشی جداگانه است.",
    "Ajouter un exercice": "افزودن تمرین",
    "Ajouter un quiz": "افزودن آزمون",
    "Nouveau quiz": "آزمون جدید",
    "Nouvel exercice": "تمرین جدید",
    "Ajouter une question": "افزودن پرسش",
    "Activer le quiz": "فعال‌سازی آزمون",
    "Désactiver le quiz": "غیرفعال‌سازی آزمون",
    "Nouvelle question": "پرسش جدید",
    "Option": "گزینه",
    "Ajouter une option": "افزودن گزینه",
    "Supprimer ce bloc": "حذف این بخش",
    "Bloc publié protégé": "بخش منتشرشده محافظت می‌شود",
    "Supprimer la question": "حذف پرسش",
    "Réponses proposées": "پاسخ‌های پیشنهادی",
    "Ajouter une réponse": "افزودن پاسخ",
    "Vrai / faux": "درست / نادرست",
    "Texte à compléter": "جای‌خالی",
    "Choix multiple": "چندگزینه‌ای",
    "Remise en ordre": "مرتب‌سازی",
    "Section": "بخش",
    "À compléter avant publication": "پیش از انتشار کامل کنید",
    "Leçon prête à être publiée.": "درس آمادهٔ انتشار است.",
    "Ajouter une section": "افزودن بخش",
    "Les champs historiques non affichés sont conservés pendant l’édition structurée.": "فیلدهای قدیمیِ نمایش‌داده‌نشده هنگام ویرایش ساختاری حفظ می‌شوند."
};

function useAdminText() {
    const { language } = useI18n();
    return (french: string): string =>
        language === "fa" ? persian[french] ?? french : french;
}

export { useAdminText };
